import { getRequest } from '.'

export const getPendingFetchCharactersJob = async () => {
  return await getPendingJob('FetchUserCharactersJob')
}

export const getPendingJobById = async <T>(jobId: string) => {
  return await getPendingJob<T>(jobId)
}

const getPendingJob = async <T>(
  job: string,
  referenceId?: number,
): Promise<wowaudit.JobStatus<T>> => {
  return await getRequest(
    `/api/jobs/${job}${referenceId ? `?reference_id=${referenceId}` : ''}`,
  )
}
